import styled from "styled-components";
import colours from "styles/colours";

export const Container = styled.span`
  margin-left: 0.5em;
  color: ${colours.focusBlue};
`;
